if (!customElements.get("flyout-drawer")) {
  customElements.define(
    "flyout-drawer",
    class FlyoutDrawer extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          drawer: "[data-drawer]",
          drawerTrigger: "[data-drawer-trigger]",
        };

        this.drawer = this.querySelector(this.selectors.drawer);
        this.drawerTrigger = this.querySelector(this.selectors.drawerTrigger);

        if (!this.drawerTrigger || !this.drawer) return;

        this.drawerTrigger.addEventListener("click", () => this.open());

        this.addEventListener("click", (event) => {
          if (event.target.hasAttribute("data-close-flyout")) {
            this.close();
          }
        });
      }

      open() {
        this.drawer.classList.add("active");
        document.body.classList.add("overflow-hidden");
        trapFocus(this.drawer);
      }

      close() {
        this.drawer.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus();
      }
    }
  );
}
